<template>
  <public-page>
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="6" lg="6" md="6" sm="12">
        <v-card v-if="!ready" elevation="4">
          <v-toolbar color="indigo" dark>
            <v-toolbar-title>Verification Token</v-toolbar-title>

            <v-spacer></v-spacer>
          </v-toolbar>
          <v-card-text>
            <p>
              We will send a verification token to your email. Introduce your
              email below and click on the link received.
            </p>
            <v-alert
              v-if="error"
              type="error"
              border="right"
              colored-border
              elevation="2"
            >
              {{ error }}
            </v-alert>
            <v-form
              ref="form"
              lazy-validation
              v-model="valid"
              id="form"
              action="POST"
              @submit.prevent="requestToken"
            >
              <v-text-field
                v-model="email"
                label="Email"
                :min="0"
                :counter="50"
                :rules="emailRules"
                required
              />
              <v-btn
                type="submit"
                color="primary"
                class="mr-4"
                form="form"
                :disabled="!valid"
                @click="validate"
              >
                Request Token
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
        <v-card v-else elevation="4">
          <v-alert :type="type">
            {{ text }}
          </v-alert>
        </v-card>
      </v-col>
    </v-row>
  </public-page>
</template>

<script>
import { API } from "@/axios-config";
import PublicPage from "@/components/PublicPage";

export default {
  name: "ActivationEmail",
  data() {
    return {
      email: "",
      valid: true,
      ready: false,
      type: "success",
      text: "",
      error: "",
      emailRules: [
        (v) => !!v || "Email is required",
        (v) =>
          /[^@ \t\r\n]+@[^@ \t\r\n]+\.[^@ \t\r\n]+/.test(v) ||
          "Invalid Email address",
      ],
    };
  },
  components: {
    PublicPage,
  },
  methods: {
    async requestToken() {
      try {
        await API.post("/api/v1/accounts/verify_resend/", {
          email: this.email,
        });
        this.type = "success";
        this.text =
          "If the email you entered is registered, you will receive an email with a link to validate your account.";
      } catch (error) {
        console.log(error);
      }
      this.ready = true;
    },
    validate() {
      this.error = null;
      this.$refs.form.validate();
    },
  },
};
</script>

<style scoped>
.v-btn,
.v-card {
  border-radius: 4px;
}
.v-card__title {
  text-transform: uppercase;
}
</style>